import * as React from 'react';

import { ProjectDiagramCreateClassDrawer } from 'src/containers/ProjectDiagram/components/classDrawer/ProjectDiagramCreateClassDrawer';
import { CreateMappingDialog } from 'src/containers/ProjectDiagram/components/dialogs/CreateMappingDialog';
import { ProjectDiagramCreateRelationshipDrawer } from 'src/containers/ProjectDiagram/components/relationshipDrawer/ProjectDiagramCreateRelationshipDrawer';
import { ProjectDiagramCreateSensitivePropertyGroupDrawer } from 'src/containers/ProjectDiagram/components/sensitivePropertyGroupDrawer/ProjectDiagramCreateSensitivePropertyGroupDrawer';
import { ProjectFileUploadPreviewDialog } from 'src/containers/ProjectFileUploadPreviewDialog/ProjectFileUploadPreviewDialog';
import { ProjectMappingSettingsDrawer } from 'src/containers/ProjectMappingSettingsDrawer/ProjectMappingSettingsDrawer';
import { ProjectModelDialog } from 'src/containers/ProjectModelDialog/ProjectModelDialog';
import { RenameProjectModelDialog } from 'src/containers/ProjectModelDialog/RenameProjectModelDialog';
import { ProjectNewResourceDialog } from 'src/containers/ProjectNewResourceDialog/ProjectNewResourceDialog';
import { ProjectResourceSuggestionsDialog } from 'src/containers/ProjectResourceSuggestionsDialog/ProjectResourceSuggestionsDialog';
import { ProjectRuleDetailDrawer } from 'src/containers/ProjectRuleDetailDrawer/ProjectRuleDetailDrawer';
import { ProjectSettingsDrawer } from 'src/containers/ProjectSettingsDrawer/ProjectSettingsDrawer';
import { ProjectVirtualGraphPreviewDialog } from 'src/containers/ProjectVirtualGraphPreviewDialog/ProjectVirtualGraphPreviewDialog';
import { PublishProjectDrawer } from 'src/containers/PublishProjectDrawer/PublishProjectDrawer';

export const ProjectOverlays: React.VFC = () => {
  return (
    <>
      <ProjectDiagramCreateClassDrawer />
      <ProjectDiagramCreateRelationshipDrawer />
      <ProjectDiagramCreateSensitivePropertyGroupDrawer />

      <ProjectRuleDetailDrawer />

      <ProjectMappingSettingsDrawer />
      <ProjectSettingsDrawer />
      <PublishProjectDrawer />

      <ProjectModelDialog />
      <RenameProjectModelDialog />
      <ProjectNewResourceDialog />
      <ProjectFileUploadPreviewDialog />
      <ProjectVirtualGraphPreviewDialog />

      <CreateMappingDialog />
      <ProjectResourceSuggestionsDialog />
    </>
  );
};
